import { WebSocketAbstract, WebSocketEnvelop } from './websocket-abstract';
import * as EventBus from 'vertx3-eventbus-client';

export class WebSocketVertx extends WebSocketAbstract {
    private _eventbus: EventBus;

    get readyState(): number {
        return this._eventbus ? this._eventbus.state : null;
    };

    connect(options: any, username: string) {
        if (options && options.length === 2) {
            var url = options[0];
            var headers = {
                keyapi: options[1]
            };
            this._connect(url, headers, username);
        }
    }

    private _connect(url: string, headers: any, username: string) {
        this._eventbus = new EventBus(url, {
            transports: 'websocket'
        });
        this._eventbus.onopen = () => {
            // Channel receive chat message
            this._eventbus.registerHandler(username, headers, (err: any, msg: any) => {
                if (msg) {
                    this.onMessage.next(msg.body);
                }
            });
            // Channel receive online message
            // this._eventbus.registerHandler('news-feed', headers, (err: any, msg: any) => {
            //     if (msg) {
            //         this.onMessage.next(msg);
            //     }
            // });
            this.stateChange();
        };
        this._eventbus.onclose = () => this.stateChange();
        this._eventbus.onerror = () => this.stateChange();
    }

    close() {
        this._eventbus.close();
    }

    send(envelop: WebSocketEnvelop): Promise<boolean> {
        return new Promise(resolve => {
            try {
                this._eventbus.publish(envelop.address, envelop.body);
                resolve(true);
            } catch(e) {
                resolve(false);
                console.warn('Send message failed', e);
            }
        });
    }
}